var map = {
	"./arsenal.png": "c370",
	"./aston-villa.png": "77d3",
	"./bornemouth.png": "261d",
	"./brighton.png": "91f4",
	"./burnley.png": "a393",
	"./chelsea.png": "ba80",
	"./crystal-palace.png": "d89e",
	"./everton.png": "1e3b",
	"./leicester.png": "68da",
	"./liverpool.png": "bcb2",
	"./manchester-city.png": "56cf",
	"./manchester-united.png": "e200",
	"./newcastle-united.png": "b423",
	"./norwich-city.png": "8a3c",
	"./sheffield-united.png": "cec4",
	"./southampton.png": "9106",
	"./tottenham-hotspur.png": "baf6",
	"./watford.png": "4a5b",
	"./westham-united.png": "f8ee",
	"./wolverhampton.png": "43ac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";